<script setup lang="ts">
import StoryView from "@/components/mobile/story/story-chapter/StoryView.vue";
import { onBeforeMount, ref } from "vue";
import { Mate, Story } from "@/types/entity";
import { useRoute } from "vue-router";
import { useStory } from "@/stores/story";
import { useMate } from "@/stores/mate";
import UserAvatar from "@/components/UserAvatar.vue";
import GlobalScrollLayout from "@/components/mobile/layout/GlobalScrollLayout.vue";
// State
const currentStory = ref<Story | null>(null);
const author = ref<Mate | null>(null);
const loading = ref(false);
const mateStore = useMate();
const route = useRoute();
const storyStore = useStory();
// Lifecycle

const prepareData = async () => {
  loading.value = true;
  try {
    const uuid = route.params.uuid as string;
    currentStory.value = await storyStore.getStoryItem(uuid);
    author.value = await mateStore.getOrFetchMate(
      currentStory.value!.mate.uuid
    );
  } finally {
    loading.value = false;
  }
};
onBeforeMount(() => {
  prepareData();
});
// Event Handler
</script>
<template>
  <global-scroll-layout :with-nav="false">
    <template #default>
      <div class="w-full h-full flex flex-col">
        <div
          v-if="loading"
          class="w-full h-full flex items-center justify-center"
        >
          <span class="loading"></span>
        </div>
        <div v-else class="p-4">
          <div class="border-b pt-2 pb-4 mb-4 flex flex-col gap-4">
            <div class="text-xl font-bold">{{ currentStory?.title }}</div>
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <user-avatar
                  :avatar-url="author!.mediaUrl"
                  class="h-[2rem] shrink-0 mr-2"
                />
                <div class="text-base-content/50">{{ author!.name }}</div>
              </div>
            </div>
          </div>
          <story-view :story="currentStory!" class="text-base" />
        </div>
      </div>
    </template>
  </global-scroll-layout>
</template>
